/* eslint-disable no-console */
import {IAppliedRule} from '../incase-domain/appliedRules';
import {httpGet, httpPost} from './http.service';

export const fetchAppliedRules = (presentationId: string): Promise<IAppliedRule[]> => {
    return httpGet(`editor/rules/${presentationId}`).catch((error) => {
        console.log(error);
    });
};

export const saveAppliedRules = (request: {appliedRules: IAppliedRule[]; presentationId: string}): Promise<IAppliedRule[]> => {
    const {appliedRules, presentationId} = request;
    return httpPost(`editor/rules/${presentationId}`, appliedRules).catch((error) => {
        console.log(error);
        if (error.response && error.response.data && error.response.status === 400) {
            throw new Error(error.response.data.message);
        }
    });
};
